import { ACTIVITY_TYPES } from "Constants/constants";

/**
 * Activity types that run a build and a deploy. This is what "the environment's
 * latest deployment" is measured over.
 *
 * One list, two consumers, deliberately not copied: the query that finds an
 * environment's newest deployment activity filters on it, and
 * `canTroubleshootActivity` re-checks it per activity. If the two ever disagreed,
 * an activity could match the newest-deployment id and still be rejected by the
 * predicate, which would hide the CTA with no way to tell why.
 *
 * Not `activityTypeBuilds` (`constants.ts:274`): that list exists to word the
 * "Deploying…" label and includes route, variable and integration-fetch types,
 * none of which build. Not the `DEPLOYMENT_ACTIVITY_TYPES` in `StatusIcon`
 * either — that one is push/deploy/redeploy only, while a failed **merge**
 * leaves its target undeployed and belongs here.
 */
export const DEPLOYMENT_ACTIVITY_TYPES: readonly string[] = [
  ACTIVITY_TYPES.ENVIRONMENT.PUSH,
  ACTIVITY_TYPES.ENVIRONMENT.DEPLOY,
  ACTIVITY_TYPES.ENVIRONMENT.REDEPLOY,
  ACTIVITY_TYPES.ENVIRONMENT.MERGE,
  ACTIVITY_TYPES.ENVIRONMENT.MERGE_PR,
  ACTIVITY_TYPES.ENVIRONMENT.BRANCH,
  ACTIVITY_TYPES.ENVIRONMENT.ACTIVATE,
  ACTIVITY_TYPES.ENVIRONMENT.INITIALIZE,
  ACTIVITY_TYPES.ENVIRONMENT.SYNCHRONIZE,
  ACTIVITY_TYPES.ENVIRONMENT.SOURCE_OPERATION,
  ACTIVITY_TYPES.ENVIRONMENT.MAINTENANCE_REDEPLOY
];
